import { render, staticRenderFns } from "./CmgLeaderboardPage.vue?vue&type=template&id=306dc690&scoped=true&lang=pug"
import script from "./cmg-leaderboard-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardPage.vue?vue&type=style&index=0&id=306dc690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306dc690",
  null
  
)

export default component.exports